import { appConfig } from '../../content/ja';

export function initShareButton(): void {
  const shareBtn = document.getElementById('share-liff-btn');

  if (!shareBtn) return;

  shareBtn.addEventListener('click', () => {
    const shareText = `「とりスタ」で友達と会った記録をスタンプで集めよう！\n${appConfig.liffUrl}`;

    // LINE Share URL
    const lineShareUrl = `https://line.me/R/share?text=${encodeURIComponent(shareText)}`;

    // Open LINE share
    window.open(lineShareUrl, '_blank');
  });
}
